import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import * as Setting from '../../utils/AuthUtils'
import ImportStageResults from './ImportStageResults';
import { api } from '../../AppConfig';

function RoutedImportStageResults(props) {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  const { hasRights } = props;
  const [previewResults, setPreviewResults] = useState([]);
  const [loading, setLoading] = useState(null);
  const [successfulImport, setSuccessfulImport] = useState(false);
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const stageQuery = useQuery({ 
    queryKey: [`stage${id}`], 
    queryFn: () => 
      fetch(api.stages().detailsById(id).href, {
        method: 'GET',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        }})
        .then((res) =>
        res.json(), 
      )
  })

  const playerQuery = useQuery({ 
    queryKey: [`players`], 
    queryFn: () => 
      fetch(api.players().list().href).then((res) =>
        res.json(), 
      )
  })

  const platformQuery = useQuery({
    queryKey: [`platforms`], 
    queryFn: () => 
      fetch(api.platforms().list().href).then((res) =>
        res.json(), 
      )
  })

  const importFileQuery = useMutation({
    mutationFn: async (p) => {
      setLoading(true);
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      const formData = new FormData();
      formData.append('uploadedFile', p.file);
      formData.append('platform', p.platform);
      const response = await fetch(api.stages().importResults(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
        },
        body: formData,
      })
      .then((res) =>
        res.json(),
      )
      return response;
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      // Invalidate and refetch
      message.success('Results successfully imported!');
      setPreviewResults(data.payLoad || []);
      setLoading(false);
      // window.location.reload(false)
    },
    onSettled: (data, variables, onMutateResult, context) => {
      // Invalidate and refetch
      // message.success('Results successfully imported!');
      // console.warn('stato di data: ', data);
      // console.warn('staot di variables: ', variables);
      // console.warn('stato di onMutateResult: ', onMutateResult);
      // console.warn('stato di context: ', context);
      // window.location.reload(false)
    },
    onError: () => {
      // console.warn('data arrivati dopo onError:', data, error, variables,context)
      setPreviewResults([]);
      message.error('Operation failed! Probably you do not have permission to do this.');
    },
  })

  const saveImportedResultsQuery = useMutation({
    mutationFn: (p) => {
      // console.warn('sono arrivato all interno di mutation con questo oggetto:', p);
      fetch(api.stages().importStore(p.stageId).href, {
        method: 'POST',
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(p.results),
      })},
    onSuccess: async () => {
      // Invalidate and refetch
      message.success('Ranking successfully updated!');
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`stage${id}`] })
      // now we redirect to tournament page
      // window.location.href = '/tournaments/' + p.tournamentId;
      setSuccessfulImport(true);
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({ queryKey: [`participants${id}`] })
      await queryClient.invalidateQueries({ queryKey: [`stage${id}`] })
      // window.location.reload(false)
    },
  })

  if (!id) return (<div></div>);
  
  return <ImportStageResults 
          id={id} 
          loading={loading}
          importResults={importFileQuery}
          previewResults={previewResults}
          saveImportedResults={saveImportedResultsQuery}
          successfulImportFlag={successfulImport}
          players={playerQuery}
          platforms={platformQuery}
          stage={stageQuery} 
          hasRights={hasRights}
          />;
}

export default RoutedImportStageResults;